import type { PageViewSourceState } from '@/shared/lib/pageViewSource';

type RecordingAnnouncementState = { showRecordingAnnouncement: true };

export const RECORDING_ANNOUNCEMENT_REDIRECT_STATE: PageViewSourceState & RecordingAnnouncementState = {
  showRecordingAnnouncement: true,
  source: 'default_tab',
};

export const hasRecordingAnnouncementState = (state: unknown) =>
  (state as null | Partial<RecordingAnnouncementState>)?.showRecordingAnnouncement === true;

export const withoutRecordingAnnouncementState = (state: unknown) => {
  if (!state || typeof state !== 'object') return null;

  const { showRecordingAnnouncement: _flag, ...rest } = state as Partial<RecordingAnnouncementState>;

  return Object.keys(rest).length > 0 ? rest : null;
};
